import { Box, Typography } from '@mui/joy';
import React from 'react'
import { IoStar } from 'react-icons/io5';
import { useThemeContext } from '../context/ThemeContext';
import CustomerJobHero from '../blocks/section/CustomerJobHero';
import PopularCategorys from '../blocks/section/PopularCategorys';
import Footer from '../component/footer/Footer';
import HeaderOne from '../component/header/HeaderOne';


const Customer = () => {
  const { isSM, isMD, isMd, isLg } = useThemeContext();

  return (
    <>
      <HeaderOne />

      <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: '446px',
            backgroundImage: `url('assets/images/multiservices copy 2.png')`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <Box
            sx={{
              margin: '2rem auto',
              width: isSM ? '194px' : isMD ? '294px' : '594px',
              position: 'absolute',
              top: '123px',
              m: 'auto 100px '

            }}
          >
            <Typography
              variant="h1"
              sx={{
                color: '#28A745',
                fontSize: '35px',
                fontWeight: 600,
                textAlign: 'justify',
                marginBottom: '1.5rem',
              }}
            >
              Lorem ipsum dolor sit amet
            </Typography>
            <Box sx={{ width: '100%', height: 'auto' }}>
              <Typography
                sx={{

                  fontSize: '20px',
                  fontWeight: 400,
                  lineHeight: '30px',
                  textAlign: 'left',

                  color: '#666666',
                }}
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{
        margin: '2rem auto',
        width: isSM ? '100%' : isMD ? '100%' : '1003px',

      }}>

        <CustomerJobHero />


      </Box>
      <Box sx={{
        margin: '2rem auto',
        width: isSM ? '100%' : isMD ? '100%' : '1153px',

      }}>

        {/* Service Content Section */}
        <Box sx={{ marginTop: '80px' }}>
          <Typography
            sx={{
              textAlign: 'center',
              fontSize: '36px',
              fontWeight: 700,
              lineHeight: '43.88px',
              color: '#28A745',
            }}
          >
            Home
            <IoStar style={{ color: '#28A745', fontSize: '2rem', marginLeft: '20px', marginRight: '20px' }} />
            Office
            <IoStar style={{ color: '#28A745', fontSize: '2rem', marginLeft: '20px', marginRight: '20px' }} />
            Apartment
          </Typography>
          <Box sx={{ marginTop: '40px' }}>
            <Typography
              sx={{
                maxWidth: '1139px',
               
                fontSize: '18px',
                fontWeight: 400,
                lineHeight: '30px',
                textAlign: 'center',
                color: '#666666',
                margin: '0 auto',
              }}
            >
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur, repudiandae.    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </Typography>
          </Box>
        </Box>

        {/* PopularCategorys */}
        <PopularCategorys />


      </Box>


      <Footer />
    </>
  )
}

export default Customer;